export default function () {
  this.loadItems();
}
